var _path, _ellipse, _path2, _path3, _path4, _path5, _ellipse2, _ellipse3, _ellipse4, _circle, _circle2, _path6, _path7, _path8;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgBee(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 152,
    height: 144,
    viewBox: "0 0 152 144",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M67.8442 120.653C56.297 118.576 56.7353 104.92 58.7239 96.7175L61.9409 96.6193C60.041 109.39 64.2244 113.991 66.5234 115.845L73.4102 115.942C76.3662 118.377 79.3913 122.73 67.8442 120.653Z",
    fill: "#2F1F0C"
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    rx: 31.6218,
    ry: 23.546,
    transform: "matrix(-0.871602 0.490214 0.537091 0.843524 79.7166 74.7749)",
    fill: "#E2BC5D"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M109.552 73.4572C102.826 59.2279 86.6462 53.3122 74.6689 51.5601C72.1017 52.4032 69.5487 53.5187 67.0694 54.9132C65.4082 55.8474 63.8488 56.8683 62.3978 57.96C89.687 61.4588 100.511 74.6034 103.704 85.1877C106.68 81.5033 108.68 77.4717 109.552 73.4572Z",
    fill: "#2D0C02"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M49.9844 75.6325C71.967 78.3942 81.1019 90.3923 83.6745 98.3303C86.6072 97.4558 89.5325 96.2278 92.3618 94.6365C93.1154 94.2126 93.8482 93.7709 94.5593 93.3129C83.2574 72.5399 65.2008 67.7181 53.1542 68.0284C51.666 70.5011 50.596 73.0674 49.9844 75.6325Z",
    fill: "#2D0C02"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M114.913 89.7779L105.95 81.2989L103.562 85.1056C107.294 88.2629 115.447 94.5202 118.203 94.2903C120.959 94.0604 118.952 84.4229 117.605 79.6328C121.105 82.5089 128.665 86.9795 130.902 81.8535C133.138 76.7275 121.166 75.4739 114.9 75.4879L114.913 89.7779Z",
    fill: "#482F13"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M100.777 103.53L96.2807 92.0408L92.4984 94.4674C94.5298 98.9138 99.2403 108.048 101.831 109.014C104.423 109.98 106.713 100.406 107.535 95.4987C109.476 99.592 114.411 106.857 118.618 103.173C122.825 99.4878 112.528 93.2532 106.854 90.5965L100.777 103.53Z",
    fill: "#482F13"
  })), _ellipse2 || (_ellipse2 = /*#__PURE__*/React.createElement("ellipse", {
    rx: 16.5546,
    ry: 14.8399,
    transform: "matrix(-0.989208 -0.146519 -0.146519 0.989208 57.8335 98.9077)",
    fill: "#482F13"
  })), _ellipse3 || (_ellipse3 = /*#__PURE__*/React.createElement("ellipse", {
    rx: 11.534,
    ry: 10.2305,
    transform: "matrix(-0.952694 0.30393 0.30393 0.952694 63.8534 98.0843)",
    fill: "#2D0C02"
  })), _ellipse4 || (_ellipse4 = /*#__PURE__*/React.createElement("ellipse", {
    rx: 5.39964,
    ry: 8.01789,
    transform: "matrix(-0.993725 0.111852 0.111852 0.993725 44.1756 98.6913)",
    fill: "#2D0C02"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    r: 3.30114,
    transform: "matrix(-0.952694 0.30393 0.30393 0.952694 66.4257 95.2854)",
    fill: "white"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    r: 2.07404,
    transform: "matrix(-0.952694 0.30393 0.30393 0.952694 45.5216 96.0846)",
    fill: "white"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M93.6084 120.746C81.8784 120.506 80.1699 106.95 80.8477 98.5375L84.0095 97.9361C84.1358 110.847 88.9888 114.735 91.5501 116.206L98.3668 115.221C101.668 117.163 105.338 120.987 93.6084 120.746Z",
    fill: "#482F13"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M54.9762 75.2526C54.9762 75.2526 56.0326 55.8873 45.0196 46.5936C34.0065 37.2999 20.6087 35.0629 15.0945 41.5971C9.58043 48.1313 14.0382 60.9624 25.0512 70.2561C36.0642 79.5498 54.9762 75.2526 54.9762 75.2526Z",
    fill: "#90C9C9"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M66.888 75.7337C66.888 75.7337 90.9151 76.8065 104.606 62.6769C118.296 48.5473 123.606 31.4845 116.466 24.566C109.326 17.6475 92.4387 23.4933 78.7482 37.6229C65.0577 51.7525 66.888 75.7337 66.888 75.7337Z",
    fill: "#90C9C9"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBee);
export default __webpack_public_path__ + "static/media/bee.063edf233eb22f8e7d3a586a6000ae41.svg";
export { ForwardRef as ReactComponent };